export const visit = (vm, at) => {
at({ "ko": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uD655\uC778\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." } } } });
};